import React from 'react';

import { Row, Col } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

const StyledDiv = styled.div`
    width: 100%;

    &.padded {
        padding: 2em 2.5em;
    }
`;

const StyledFormItemContainer = styled.div`
    .ant-form-item {
        margin-bottom: ${(props) => props.$rowsGap};

        .ant-form-item-label {
            padding: 0 0 0.5em 0;
            text-transform: uppercase;
            font-size: 0.8rem;
            height: auto;

            label {
                height: auto;
                font-size: 0.85rem;
                font-weight: 400;
                color: ${(props) => props.theme.TextColorMuted};

                &.ant-form-item-required {
                    &::before {
                        content: none;
                        display: none;
                        margin: 0;
                    }

                    &::after {
                        align-self: center;
                        display: block;
                        flex: 0 0 0.4rem;
                        content: '';
                        height: 0.4rem;
                        width: 0.4rem;
                        line-height: 0;
                        margin: 0 0 0 0.25em;
                        border-radius: 0.25em;
                        background-color: ${(props) => props.theme.DangerColor};
                        position: static;
                        top: auto;
                    }
                }

                &.with-icon {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }
            }
            small {
                display: block;
                font-size: ${(props) => props.theme.FontSizeSm};
                color: ${(props) => props.theme.TextColorMuted};
                text-transform: lowercase;
            }
        }

        .char-counter-container {
            font-size: 0.75rem;
            text-align: right;
            padding: 0.25em 1em;
            position: absolute;
            right: 0;
            top: -20px;
        }

        .ant-form-item-control {
            .ant-form-item-control-input-content {
                > .ant-segmented:not(.ant-segmented-block) {
                    display: flex;
                    max-width: 100%;
                    width: fit-content;
                }
            }
        }

        .ant-form-item-explain {
            font-size: 0.8rem;
            text-transform: uppercase;
            padding: 0.25em 1em;
            opacity: 0.75;
        }

        &.ant-form-item-has-error {
            .ant-btn {
                border-color: ${(props) => props.theme.DangerColor} !important;
                color: ${(props) => props.theme.DangerColor} !important;

                &:hover,
                &:focus {
                    border-color: ${(props) => props.theme.DangerColor} !important;
                    color: ${(props) => props.theme.DangerColor} !important;
                }
            }

            .ant-select-arrow {
                color: ${(props) => props.theme.DangerColor};
            }

            .ant-form-item-explain {
                color: ${(props) => props.theme.DangerColor};
                font-size: 0.75rem;
                padding: 0;
                opacity: 1;
            }
        }
    }

    &.inline {
        .ant-form-item-row {
            flex-direction: row !important;
            align-items: center;

            .ant-form-item-label {
                padding: 0 1em 0 0;
            }
        }
    }
`;

const NwFakeFormButtonsBar = ({ left, right, marginTop = '.5em' }) => {
    return (
        <Row justify="space-between" style={{ margin: `${marginTop} 0 1em 0` }}>
            <Col>{left || <span></span>}</Col>
            <Col>{right || <span></span>}</Col>
        </Row>
    );
};

const NwFakeForm = ({ horizontal, inline, padded, small, children }) => {
    const getClassName = () => {
        let cn = 'ant-form';
        if (horizontal) {
            cn += ' ant-form-horizontal';
        } else {
            if (inline) {
                cn += ' ant-form-inline';
            } else {
                cn += ' ant-form-vertical';
            }
        }
        if (small) {
            cn += ' ant-form-small';
        }
        if (padded) {
            cn += ' padded';
        }
        return cn;
    };

    return <StyledDiv className={getClassName()}>{children}</StyledDiv>;
};

const NwFakeFormItem = ({ error, label, additionalLabel, control, required, icon, rowsGap = '0.5rem' }) => {
    const Icon = icon ? <NwIcon icon={icon} /> : null;
    return (
        <StyledFormItemContainer
            className={`nw-form-item-container${error ? ' ant-form-item-has-error' : ''}`}
            $rowsGap={rowsGap}
        >
            <div className={`ant-form-item${error ? ' ant-form-item-has-error' : ''}`}>
                <div className="ant-row ant-form-item-row">
                    {label && (
                        <div className="ant-col ant-form-item-label">
                            <label
                                className={`${required ? 'ant-form-item-required ' : ''}${icon ? 'with-icon ' : ''} ant-form-item-no-colon`}
                            >
                                {Icon} {label}
                            </label>
                            {additionalLabel && <small className="additional-label">{additionalLabel}</small>}
                        </div>
                    )}

                    <div className="ant-col ant-form-item-control">
                        <div className="ant-form-item-control-input">
                            <div className="ant-form-item-control-input-content">{control}</div>
                        </div>
                        {error ? (
                            <div className="ant-form-item-explain ant-form-item-explain-error">{error}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </StyledFormItemContainer>
    );
};

export { NwFakeForm, NwFakeFormButtonsBar, NwFakeFormItem };
